import { GoogleAddressResponse } from '../../types'

const formatGoogleLatLonResponse = async (googleResponse: any): Promise<GoogleAddressResponse> => {
  if (!googleResponse) return {}

  const [address_number, address, address_neighbourhood, address_city, address_uf, address_country, address_zip_code] =
    googleResponse.address_components

  return {
    latitude: googleResponse.geometry.location.lat,
    longitude: googleResponse.geometry.location.lng,
    number: address_number.long_name,
    street: address.long_name,
    neighbourhood: address_neighbourhood.long_name,
    city: address_city.long_name,
    state: address_uf.long_name,
    country: address_country.long_name,
    zip_code: address_zip_code.long_name,
  }
}

export default formatGoogleLatLonResponse
